import { FormalizeButton } from '@ztechapps/webui.data-tools'
import type { File } from '@ztechapps/common.contract'
import type { TemplateVariables } from '../Conversation/Context'
import type { InsertMessageFunction } from '../Chat/Context'
import { AttachFileButton } from '../Chat/ChatButtons/AttachFileButton'
import { useConversationHost } from '../ConversationHost'
import { ComposerToolbarEnd } from '../Channel/ComposerToolbarEnd'

export type ModalComposerToolbarProps = {
  message: string
  setMessage: (message: string) => void
  insertMessage: InsertMessageFunction
  attachments: File[]
  onAttach: (files: File[]) => void
  templateVariables?: TemplateVariables
  // The owning modal (BatchReplyModal, ComposeConversation) computes this from its own
  // sending/replying state ORed with `formalizing` — both live in the modal owner, not here, so
  // send and formalize lock each other out. This component only renders with it.
  disabled?: boolean
  formalizing: boolean
  onFormalize: (content: string) => Promise<string>
}

export const ModalComposerToolbar = ({
  message,
  setMessage,
  insertMessage,
  attachments,
  onAttach,
  templateVariables = {} as TemplateVariables,
  disabled,
  formalizing,
  onFormalize,
}: ModalComposerToolbarProps) => {
  const { communicationTemplateCategories, templateSelectComponent: TemplateSelect } = useConversationHost()

  return (
    <ComposerToolbarEnd
      templateSelect={
        <TemplateSelect
          insertMessage={insertMessage}
          templateCategory={communicationTemplateCategories}
          templateVariables={templateVariables}
          disabled={disabled}
          // The modal composer sits low in the viewport, so the menu opens upward over the
          // message history instead of draping across the modal footer below it.
          menuPlacement="top"
        />
      }
    >
      <FormalizeButton
        message={message}
        isFormalizing={formalizing}
        onFormalize={onFormalize}
        onFormalized={setMessage}
        variant="link"
        disabled={disabled}
      />
      {/* The native chooser uploads through the same path without rendering the Uppy dashboard inline
          inside the editor header inside the modal. */}
      <AttachFileButton
        attachments={attachments}
        onAttach={onAttach}
        disabled={disabled}
        mode="simple"
        variant="link"
      />
    </ComposerToolbarEnd>
  )
}
